/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_OtherInputs */

const en_contact_topic_other = /** @type {(inputs: Contact_Topic_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

const pl_contact_topic_other = /** @type {(inputs: Contact_Topic_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś innego`)
};

/**
* | output |
* | --- |
* | "Something else" |
*
* @param {Contact_Topic_OtherInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_topic_other = /** @type {((inputs?: Contact_Topic_OtherInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_OtherInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_topic_other(inputs)
	return en_contact_topic_other(inputs)
});